<template>
  <div :class="size">
    <img :src="imgUrl" :alt="alt" />
  </div>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'LogoView',
  props: {
    size: {
      type: String,
      default: 'medium',
      validator: (prop) =>
        ['tiny', 'small', 'medium', 'extra-medium', 'medium-large', 'large', 'full'].includes(prop)
    },
    imgUrl: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: false
    }
  }
};
</script>

<style scoped>
div {
  &.tiny {
    img {
      width: var(--ce-70px);
    }
  }

  &.small {
    img {
      width: var(--ce-100px);
    }
  }

  &.medium {
    img {
      width: var(--ce-140px);
    }
  }

  &.medium-large {
    img {
      width: var(--ce-200px);
    }
  }

  &.extra-medium {
    img {
      width: var(--ce-250px);
    }
  }

  &.large {
    img {
      width: var(--ce-350px);
    }
  }

  &.full {
    img {
      width: 100%;
    }
  }
}
</style>
